import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  additionalTabIdentifier?: string
  bgColor?: string
  iconPath?: string
  isOpenOverride?: boolean
  name?: string
  onOpen?: () => void
  startOpen?: boolean
  tabType?: string | null
}

export const AncientTabBody: React.FC<Props> = ({
  additionalTabIdentifier,
  bgColor,
  children,
  isOpenOverride,
  iconPath,
  name,
  onOpen,
  startOpen,
  tabType,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isInitialized, setIsInitialized] = useState<boolean>(false)

  const openAccordion = () => {
    setIsOpen(!isOpen)
  }
  useEffect(() => {
    if (isOpen) {
      onOpen?.()
    }
    if (startOpen && !isInitialized) {
      setIsOpen(true)
    }
    setIsInitialized(true)
  }, [isOpen])

  useEffect(() => {
    if (isOpenOverride !== undefined) {
      setIsOpen(isOpenOverride)
    }
  }, [isOpenOverride])

  return (
    <div className='mb-5'>
      <div className='cursor-pointer' onClick={openAccordion}>
        <div
          className={
            'd-flex align-items-center rounded p-5 ' +
            (bgColor != undefined ? bgColor : 'bg-secondary')
          }
        >
          <span className='svg-icon svg-icon-info me-5'>
            <KTSVG
              path={iconPath != undefined ? iconPath : '/media/icons/duotune/abstract/abs027.svg'}
              className='svg-icon-2x'
            />
          </span>
          <div className='flex-grow-1 me-2 col-5'>
            <span className='fw-bold text-gray-800 text-hover-primary fs-6 keychainify-checked'>
              {name}
            </span>
            <span className='text-muted fw-semibold d-block'>{tabType}</span>
          </div>
          {additionalTabIdentifier && (
            <div className='flex-grow-1 me-2 col-3'>{additionalTabIdentifier}</div>
          )}
          <span className='fw-bold text-info py-1'>
            <i className={'fas fs-2x ' + (isOpen ? ' fa-caret-down' : 'fa-caret-right')}></i>
          </span>
        </div>
      </div>
      <div>{isOpen ? <>{children}</> : null}</div>
    </div>
  )
}
